<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <!-- 头部：搜索条件 + 操作按钮 -->
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <!-- 分类名称 搜索 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >分类名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>

            <!-- 查询按钮 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >查询</el-button
              >
            </div>

            <!-- 重置按钮 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <!-- 新建按钮 -->
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleCreate"
                >+ 新建</el-button
              >
            </div>
          </div>
        </div>
      </template>

      <!-- 列：状态（开关切换） -->
      <template slot="state" slot-scope="{ row }">
        <el-switch
          :value="row.state"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>

      <!-- 列：操作（编辑 / 删除） -->
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          >删除</el-button
        >
      </template>
    </avue-crud>

    <!-- 新增 / 编辑 分类 弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      :title="`${form.id ? '修改分类' : '新增分类'}`"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form ref="form" v-model="form" :option="formOption">
        <!-- 分类名称 -->
        <template slot="name">
          <el-input
            v-model="form.name"
            maxlength="20"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'name')"
            type="text"
            clearable
          />
        </template>

        <!-- 排序值（数字） -->
        <template slot="sort">
          <el-input
            v-model="form.sort"
            maxlength="4"
            placeholder="请输入"
            onkeyup="this.value=this.value.replace(/[^\d]/g,'')"
            @blur="salaryDianChange($event, 'sort')"
            type="text"
            clearable
          />
        </template>

        <!-- 启用状态 开关 -->
        <template slot="state">
          <el-switch
            v-model="form.state"
            :inactive-value="2"
            :active-value="1"
          ></el-switch>
        </template>

        <!-- 表单底部按钮 -->
        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="submit(form)"
            :loading="showLoadingForm"
            >保存</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
// 新闻分类相关接口
import {
  newsClassifyList,
  newsClassifyAdd,
  newsClassifyUpdate,
  newsClassifyDelete,
  newsClassifyState,
} from "@/api/news/classify";

export default {
  name: "index",
  data() {
    return {
      // 搜索条件
      searchData: {
        name: "", // 分类名称
      },
      // 分页参数
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], // 列表数据
      showLoading: false, // 列表加载中
      showLoadingForm: false, // 表单提交中（防重提交）
      dialogVisible: false, // 新增/编辑弹窗显隐

      // 表格配置
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "ID", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false, // 隐藏自带编辑按钮
        delBtn: false, // 隐藏自带删除按钮
        selection: false,
        tip: false,
        column: [
          {
            label: "分类名称",
            prop: "name",
          },
          {
            label: "排序",
            prop: "sort",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "状态",
            prop: "state",
          },
        ],
      },

      // 表单数据
      form: {
        name: "", // 分类名称
        sort: "", // 排序值
        state: 1, // 状态：1启用 2停用
      },

      // 表单配置
      formOption: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: "120",
        row: true,
        column: [
          {
            label: "分类名称",
            prop: "name",
            type: "text",
            maxlength: 20,
            placeholder: "请输入",
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "排序值",
            prop: "sort",
            type: "text",
            maxlength: 6,
            placeholder: "请输入",
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "启用",
            prop: "state",
            type: "text",
            span: 24,
            rules: [
              {
                required: true,
                message: "",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    // 列表初始化 / 分页变更回调
    onLoad() {
      this.showLoading = true;
      newsClassifyList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      })
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200) {
            const data = res.data || {};
            this.tableData = data.records || [];
            this.page.total = data.total || 0;
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    // 查询
    handleSearch() {
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 重置
    handleReset() {
      this.searchData = {
        name: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 新建分类
    handleCreate() {
      this.resetForm();
      this.dialogVisible = true;
    },

    // 编辑分类
    handleEdit(row) {
      this.form = {
        id: row.id,
        name: row.name,
        sort: row.sort,
        state: row.state,
      };
      this.dialogVisible = true;
    },

    // 删除分类
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        newsClassifyDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },

    // 切换状态（启用 / 停用）
    handleSwitch(e, id) {
      newsClassifyState({
        id: id,
        state: e,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
          }
          this.onLoad();
        })
        .catch(() => {
          this.onLoad();
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        name: "",
        sort: "",
        state: 1,
      };
    },

    // 输入框失焦时同步表单字段（兼容 onkeyup 处理后的值）
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 表单提交（新增 / 编辑）
    submit(form) {
      this.$refs.form.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.showLoadingForm) return;
        this.showLoadingForm = true;

        const params = {
          ...form,
          sort: Number(form.sort),
          state: Number(form.state),
        };
        const request = form.id
          ? newsClassifyUpdate(params)
          : newsClassifyAdd(params);

        request
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.dialogVisible = false;
              setTimeout(() => {
                this.resetForm();
              }, 500);
              this.onLoad();
            }
            this.showLoadingForm = false;
          })
          .catch(() => {
            this.showLoadingForm = false;
          });
      });
    },
  },
};
</script>

<style scoped></style>
